/* eslint-disable jsx-a11y/anchor-is-valid */
import LOGO from "../assets/images/logo.png"
import React, { Component } from "react"
import { Modal } from "react-bootstrap"
import {
  locale,
  tokens,
  select_style,
  required,
  // alert
  success,
  success_url,
  alert,
  alert_url,
  // function
  logout,
  number_zero,
  format_date,
  toFixed,
  total,
  validate,
  random_charactor,
  float,
  // api
  GET,
  POST,
  PUT,
  DELETE,
  error_message,
  // storage
  removeStorage,
  getStorage,

  validate_email,
  validate_th,
  validate_en,
  validate_en_number,

  LinktoBase64,
  // component
  DatePicker,
} from "../components/CustomComponent.js";
import "../assets/css/bootstrap.css";
import "../assets/css/index.css";
export default class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: "",
      password: "",
      loading: false,
    }
  }

  componentDidMount() {
    removeStorage();
  }
  render() {
    return (
      <div className="w-100">
        {this.state.loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <div className="row background pt-5" style={{ height: "100vh" }}>
          <div className="col-11 col-sm-8 col-md-7 col-lg-6 col-xl-5 col-xxl-4 mx-auto my-auto">
            <div className="d-flex justify-content-center mb-2">
              <img src={LOGO} style={{ width: 170 }} />
            </div>
            <div className="card shadow border-0 blur" style={{ borderRadius: 32, background: "#ffffff70" }}>
              <div className="w-100 p-4 text-center">
                <h1><b>404</b></h1>
                <h3 className="mb-5">ขออภัย ไม่พบหน้าเว็บไซต์ที่คุณต้องการ</h3>
                <button type="button" className="btn btn-orange w-100 mb-2" onClick={() => { window.location.href = "/login" }}>
                  กลับหน้าแรก
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
